import { render, staticRenderFns } from "./dataparams.vue?vue&type=template&id=5d8210e7&scoped=true"
import script from "./dataparams.vue?vue&type=script&lang=js"
export * from "./dataparams.vue?vue&type=script&lang=js"
import style0 from "./dataparams.vue?vue&type=style&index=0&id=5d8210e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8210e7",
  null
  
)

export default component.exports